module.exports = __webpack_public_path__ + "img/weibo.da2c6fd5.png";